/**
 * Пресеты фона блока текста новости (градиенты). ID в БД: contentBackground.
 * Фон карточки целиком — отдельные пресеты: cardBackground (см. NEWS_CARD_BACKGROUND_PRESETS).
 */
export const NEWS_CONTENT_BACKGROUND_PRESETS = [
  // светлые
  {
    id: 'nw-bg-l1',
    label: 'Кремовый персик',
    group: 'light',
    gradient: 'linear-gradient(135deg, #fff9f0 0%, #ffe4c9 45%, #ffd6a8 100%)',
  },
  {
    id: 'nw-bg-l2',
    label: 'Мятный бриз',
    group: 'light',
    gradient: 'linear-gradient(125deg, #e8fff3 0%, #c8f7dc 50%, #a8e6cf 100%)',
  },
  {
    id: 'nw-bg-l3',
    label: 'Небесная пастель',
    group: 'light',
    gradient: 'linear-gradient(135deg, #f0f4ff 0%, #dbeafe 40%, #e0e7ff 100%)',
  },
  {
    id: 'nw-bg-l4',
    label: 'Розовый рассвет',
    group: 'light',
    gradient: 'linear-gradient(160deg, #fff5f7 0%, #fce7f3 45%, #fbcfe8 100%)',
  },
  {
    id: 'nw-bg-l5',
    label: 'Слоновая кость',
    group: 'light',
    gradient: 'linear-gradient(180deg, #fafaf9 0%, #f5f5f4 45%, #e7e5e4 100%)',
  },
  // тёмные
  {
    id: 'nw-bg-d1',
    label: 'Глубокий океан',
    group: 'dark',
    gradient: 'linear-gradient(145deg, #0c1929 0%, #1e3a5f 55%, #0f172a 100%)',
  },
  {
    id: 'nw-bg-d2',
    label: 'Ночной пурпур',
    group: 'dark',
    gradient: 'linear-gradient(135deg, #1a1025 0%, #2d1b4e 50%, #1e1b4b 100%)',
  },
  {
    id: 'nw-bg-d3',
    label: 'Изумрудная тень',
    group: 'dark',
    gradient: 'linear-gradient(135deg, #0d1f17 0%, #14532d 45%, #064e3b 100%)',
  },
  {
    id: 'nw-bg-d4',
    label: 'Уголь и бордо',
    group: 'dark',
    gradient: 'linear-gradient(140deg, #1c1917 0%, #292524 40%, #451a1a 100%)',
  },
  {
    id: 'nw-bg-d5',
    label: 'Графит',
    group: 'dark',
    gradient: 'linear-gradient(160deg, #18181b 0%, #27272a 50%, #3f3f46 100%)',
  },
];

const BY_ID = Object.fromEntries(NEWS_CONTENT_BACKGROUND_PRESETS.map((p) => [p.id, p]));

export function getNewsContentBackgroundCss(id) {
  if (!id || typeof id !== 'string') return '';
  const p = BY_ID[id.trim()];
  return p ? p.gradient : '';
}

export function isValidNewsContentBackgroundId(id) {
  return typeof id === 'string' && !!BY_ID[id.trim()];
}

/** Пресеты фона всей карточки новости в ленте (не путать с contentBackground — фон области текста). */
export const NEWS_CARD_BACKGROUND_PRESETS = [
  {
    id: 'nw-card-l1',
    label: 'Карточка: лёд и небо',
    group: 'light',
    gradient: 'linear-gradient(145deg, #e0f2fe 0%, #dbeafe 40%, #e0e7ff 100%)',
  },
  {
    id: 'nw-card-l2',
    label: 'Карточка: тёплый пергамент',
    group: 'light',
    gradient: 'linear-gradient(135deg, #fff8f0 0%, #ffedd5 50%, #fed7aa 100%)',
  },
  {
    id: 'nw-card-l3',
    label: 'Карточка: сиреневый туман',
    group: 'light',
    gradient: 'linear-gradient(160deg, #faf5ff 0%, #f3e8ff 45%, #e9d5ff 100%)',
  },
  {
    id: 'nw-card-l4',
    label: 'Карточка: мятная свежесть',
    group: 'light',
    gradient: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 50%, #a7f3d0 100%)',
  },
  {
    id: 'nw-card-l5',
    label: 'Карточка: жемчужный серый',
    group: 'light',
    gradient: 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 55%, #cbd5e1 100%)',
  },
  {
    id: 'nw-card-d1',
    label: 'Карточка: полночь',
    group: 'dark',
    gradient: 'linear-gradient(155deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
  },
  {
    id: 'nw-card-d2',
    label: 'Карточка: бордо',
    group: 'dark',
    gradient: 'linear-gradient(140deg, #1c1917 0%, #3f1d2b 45%, #4c0519 100%)',
  },
  {
    id: 'nw-card-d3',
    label: 'Карточка: глубокий сапфир',
    group: 'dark',
    gradient: 'linear-gradient(135deg, #172554 0%, #1e3a8a 50%, #0f172a 100%)',
  },
  {
    id: 'nw-card-d4',
    label: 'Карточка: северное сияние',
    group: 'dark',
    gradient: 'linear-gradient(130deg, #042f2e 0%, #134e4a 40%, #164e63 100%)',
  },
  {
    id: 'nw-card-d5',
    label: 'Карточка: уголь',
    group: 'dark',
    gradient: 'linear-gradient(165deg, #18181b 0%, #27272a 45%, #3f3f46 100%)',
  },
];

const CARD_BY_ID = Object.fromEntries(NEWS_CARD_BACKGROUND_PRESETS.map((p) => [p.id, p]));

export function getNewsCardBackgroundCss(id) {
  if (!id || typeof id !== 'string') return '';
  const p = CARD_BY_ID[id.trim()];
  return p ? p.gradient : '';
}

export function isValidNewsCardBackgroundId(id) {
  return typeof id === 'string' && !!CARD_BY_ID[id.trim()];
}

/** Пресеты фона карточки «Голосование» — те же ID, что у карточки новости (поле `cardBackground` в БД). */
export const NEWS_POLL_CARD_BACKGROUND_PRESETS = NEWS_CARD_BACKGROUND_PRESETS;
